import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'
import { H2 } from 'ui/shorthands/Texts'
import { Link } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },

  h2: {
    marginTop: theme.spacing(8),
  },

  link: {
    fontSize: 14,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}))

const Root: React.FC = () => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  return (
    <Layout header={<AppBarCommon />}>
      <div className={classes.root}>
        <H2 className={classes.h2}>{t('医療従事者の方')}</H2>
        <Link href="/medical" className={classes.link}>
          {t('YaDoc Quickログインはこちら')}
        </Link>
        <Link
          href="https://www.yadoc.jp/quick"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          {t('YaDoc Quickとは')}
        </Link>

        <H2 className={classes.h2}>{t('一般の方')}</H2>
        <Link
          href="https://www.yadoc.jp/quick/personal"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          {t('YaDoc Quickとは')}
        </Link>
      </div>
    </Layout>
  )
}

export default Root
